/* External dependencies */
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';

/* Local dependencies */
import { store, AppDispatch } from './store';
import { restoreSessionAction } from '../components/webApp/authredux/actions';

const RestoreSession: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const user = localStorage.getItem('user');

    if (isAuthenticated === 'true' && user) {
      dispatch(restoreSessionAction(JSON.parse(user)));
    }
  }, [dispatch]);

  return <>{children}</>;
};

const WrapWithProvider = ({ element }: { element: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <RestoreSession>{element}</RestoreSession>
    </Provider>
  );
};

export default WrapWithProvider;
